import React, { useEffect, useState } from 'react'
import { Alert, Button, Popover, PopoverBody, PopoverHeader, Progress } from 'reactstrap'
import { gql, useApolloClient } from '@apollo/client'
import { RepsTypeAhead } from '../../TaskManagement/TaskComponents/TypeAheadComponents'

const UPDATE_SUBROGATION_CLAIM = gql`
  mutation UpdateSubrogationClaim($input: UpdateSubrogationClaimMutationInput!) {
    updateSubrogationClaim(input: $input) {
      ok
      errors {
        field
        messages
      }
    }
  }
`


const UpdateSubroClaimInfo = ({ claimId, refetch, title = "", name, open, target, handleClose, value }) => {
    const apolloClient = useApolloClient()
    const [fieldValue, setFieldValue] = useState(value || '')
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")

    useEffect(() => {
        setFieldValue(value || '')
        setError("")
    }, [value, open])

    const closeEditor = () => {
        handleClose()
        setFieldValue(value || '')
        setError("")
    }

    const getRepId = (rep) => typeof rep === 'string' ? rep : rep?.id || rep?.value

    const handleUpdateClaim = async () => {
        if (!claimId) return

        setLoading(true)
        setError("")

        const input = { claimId }
        if (name === 'assignedToIds') {
            input[name] = Array.isArray(fieldValue) ? fieldValue.map(getRepId).filter(Boolean) : []
        } else {
            input[name] = fieldValue
        }

        try {
            const result = await apolloClient.mutate({
                mutation: UPDATE_SUBROGATION_CLAIM,
                variables: { input },
            })
            const { ok, errors } = result?.data?.updateSubrogationClaim || {}
            if (ok) {
                await refetch?.()
                handleClose()
                setFieldValue('')
                setError("")
            } else {
                setError(errors?.[0]?.messages?.toString() || "Unable to update assigned reps.")
            }
        } catch (err) {
            setError(err.message || "Unable to update assigned reps.")
        } finally {
            setLoading(false)
        }
    }

    return (
        <Popover placement="auto-start" isOpen={open} target={target} toggle={closeEditor} trigger="legacy" style={{ minWidth: '250px' }}>
            <PopoverHeader onClick={closeEditor}>{title}&nbsp;&nbsp;<i className="fa fa-times-circle float-right" /></PopoverHeader>
            <PopoverBody>
                {error && <Alert color="danger">{error}</Alert>}
                <div className="pb-2">
                    {name === 'assignedToIds' && (
                        <RepsTypeAhead
                            onChange={setFieldValue}
                            defaultValue={fieldValue}
                            permissions={["custom_can_assign_to_incident"]}
                        />
                    )}
                </div>
                {loading ? (
                    <Progress animated color="info" value={100} />
                ) : (
                    <div className="d-flex justify-content-end mt-3">
                        <Button color="primary" size="sm" onClick={handleUpdateClaim}>Submit</Button>
                    </div>
                )}
            </PopoverBody>
        </Popover>
    )
}

export default UpdateSubroClaimInfo
